import ApiService from "../ApiService";

const branchService = {
   
    allBranches() {
        return ApiService.get(`/branch`)
    },

    searchBranche(page, PerPage, searchString){
        return ApiService.get(`/branch/search?page=${page}&perPage=${PerPage}&searchString=${searchString}`)
    },

    getBranchByCity(page, PerPage, searchString) {
        return ApiService.get(`/branch/with-cities/?page=${page}&perPage=${PerPage}&searchString=${searchString}`);
    },

    getBranchesByprovider(providerId) {
        providerId = providerId || 0;
        return ApiService.get(`/branch/provider/${providerId}`);
    },

    createBranch(formData) {
        return ApiService.post("/branch", formData);
    },

    getByProviders(data) {
        return ApiService.post("/branch/byProviders", data);
    },

    createShippingFee(formData) {
        return ApiService.post("/provider-schedule-range", formData);
    },
    deleteBranch(formData) {
        return ApiService.post(`/branch/remove/`, formData);
    },
    updateBranch(id, formData) {
        return ApiService.post(`/branch/update?id=${id}`, formData);
    }
};

export default branchService;